import React from 'react';
import type { MediaProvider } from '@atlaskit/editor-common/provider-factory';
import type { MediaOptions } from '@atlaskit/editor-plugins/media/types';
import { MediaClientProvider } from '@atlaskit/media-client-react';

interface MediaWrapperProps {
    children: React.ReactNode;
    mediaOptions?: MediaOptions;
}

export const MediaWrapper = ({ children, mediaOptions }: MediaWrapperProps) => {
    const [mediaConfig, setMediaConfig] = React.useState<MediaProvider>();

    React.useEffect(() => {
        if (mediaOptions?.provider) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            mediaOptions.provider.then(setMediaConfig).catch(() => {});
        }
    }, [mediaOptions]);

    if (!mediaConfig) {
        return children;
    }

    return (
        <MediaClientProvider
            clientConfig={{ ...mediaConfig, authProvider: mediaConfig.viewMediaClientConfig.authProvider }}
        >
            {children}
        </MediaClientProvider>
    );
};
